// extracted by mini-css-extract-plugin
module.exports = {"info":"UserGroupsTable_info__3TftP"};